export const config = {
    appId: '17b5e0d2-b1dc-45f9-afb2-4e00b7c55669',
    //redirectUri: 'http://localhost:3000/',
    //redirectUri: 'https://scheduletooutlook-staging.mcmaster.ca',
    redirectUri: 'https://timetabletooutlook.mcmaster.ca',
    //redirectUri: 'https://schedule-to-outlook-main-schedule-to-outlook-test.apps.ocpprd01.mcmaster.ca',
    authority: 'https://login.microsoftonline.com/44376307-b429-42ad-8c25-28cd496f4772',
};